import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { Project } from './project';
import { AbstractUiEntityStore } from '../../../data/abstract-ui-entity.store';

export interface ProjectsState extends EntityState<Project, number>  {
	ui: {
		totalElements: number
	};
}

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'projects' })
export class ProjectsStore extends AbstractUiEntityStore<ProjectsState> {
	constructor() {
		super({
			ui: {
				totalElements: 0
			}
		})
	}

	// decreaseTotalUnread(): void {
	// 	this.updateUi({
	// 		totalUnread: this._value().ui.totalUnread - 1
	// 	})
	// }

	updateTotalElements(totalElements: number) {
		this.updateUi({
			totalElements
		})
	}

	// updateTotal(total: number) {
	// 	this.updateUi({
	// 		total
	// 	})
	// }
}